import { usePermissions } from "./PermissionContext";

export function Can({
  permission,
  endpoint,
  method,
  ownerId,
  projectId,
  fallback = null,
  children,
}) {
  const {
    can,
    hasPermission,
    loading,
  } = usePermissions();

  if (loading) {
    return fallback;
  }

  const targetEndpoint =
    permission?.endpoint ??
    endpoint;

  const targetMethod =
    permission?.method ??
    method;

  if (!targetEndpoint || !targetMethod) {
    console.error(
      "Can requires a permission or endpoint/method"
    );

    return fallback;
  }

  /**
   * Only evaluate scope when one was explicitly provided.
   */
  const hasScope =
    ownerId !== undefined ||
    projectId !== undefined;

  const allowed = hasScope
    ? can(
        targetEndpoint,
        targetMethod,
        {
          ownerId,
          projectId,
        }
      )
    : hasPermission(
        targetEndpoint,
        targetMethod
      );

  return allowed
    ? children
    : fallback;
}